import React from 'react'
import './CookieConsent.css'

const CookieConsent = (props) => (
	<button id="privado-changepreferences">Cookie-Einstellungen</button>
)

export default CookieConsent